import React from "react";
import { Navigate, RouteProps } from "react-router-dom";

const LoginRoute: React.FC<RouteProps> = ({ children }) => {

    // Redirect to login page if no accounts are available
    if (localStorage.getItem('login_token')) {
        return <Navigate to="/home" />;
    }

    return <>{children}</>;
};

export default LoginRoute;
